var render = function (_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "rb-breadcrumbs m-dynamic--x" }, [
    _c(
      "ul",
      { staticClass: "rb-breadcrumbs__list" },
      _vm._l(_vm.props.breadcrumbs, function (breadcrumb, index) {
        return _c("li", { key: index, staticClass: "rb-breadcrumbs__item" }, [
          !breadcrumb.isLast
            ? _c(
                "a",
                {
                  staticClass: "rb-breadcrumbs__link",
                  attrs: { href: breadcrumb.link },
                },
                [_vm._v("\n        " + _vm._s(breadcrumb.label) + "\n      ")]
              )
            : _c(
                "a",
                {
                  staticClass:
                    "rb-breadcrumbs__link rb-breadcrumbs__link--active",
                },
                [_vm._v("\n        " + _vm._s(breadcrumb.label) + "\n      ")]
              ),
          _vm._v(" "),
          !breadcrumb.isLast
            ? _c("span", { staticClass: "rb-breadcrumbs__separator" }, [
                _vm._v(" | "),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }